import axios from 'axios'
import store from '@/store/index.js'

axios.defaults.withCredentials = true

axios.interceptors.response.use(response => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  const { data } = response
  if ((data && data.errors)) {
    data.errors.forEach(error => {
      if ((error.extensions && error.extensions.code === 'AUTH_NOT_AUTHORIZED') || (error.extensions && error.extensions.code === 'AUTH_NOT_AUTHENTICATED')) {
        store.dispatch('user/LOGOUT')
      }
    })
  }
  return response
}, error => {
  if (error.response) {
    const { data } = error.response
    if ((data && data.errors)) {
      data.errors.forEach(error => {
        if (error.extensions && error.extensions.code === 'AUTH_NOT_AUTHENTICATED') {
          store.dispatch('user/LOGOUT')
        }
      })
    }
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error)
})

export const gql = ({ query, variables }) => {
  return axios.post(`${process.env.VUE_APP_GQL_URI}`, {
    query,
    variables
  })
}
